import styled from "@emotion/styled";
import {Box} from "@mediaspace/shared/styled";
import {Typography} from "@kaltura/ds-react-components";
import { multiLineEllipsisStyles } from "@mediaspace/shared/utils";

export const StyledContainer = styled("a")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(2),
    textDecoration: "none",
    "& .kms-ds-media-page-sidebar-related-media-item-thumb": {
        width: 144,
        height: 80,
    }
}));




export const StyledDetails = styled(Box)(({ theme }) => ({
    width: "100%"
}));

export const StyledTruncteContainer = styled("div")(({ theme }) => ({
    display: "inline-block"
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone1
}));

export const StyledTruncatedScheduling = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone3,
    ...multiLineEllipsisStyles(2, theme.kaltura.typography.body2Highlight),
}));


export const StyledDateContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center"
}));
